const legacyConsultationCopy = "Свяжитесь с нами для бесплатной консультации и расчёта стоимости";
const reviewedConsultationCopy = "Передайте параметры проекта для расчёта стоимости заказа.";

import type { CatalogueScopeState } from './catalogue-scope';

/** Prior reviewed paths are fallback only when current server classification is unknown. */
const reviewedPaths = new Set<string>([
    "/shop/category/bystrovozvodimye-zdaniya-iz-metallokonstruktsiy",
    "/shop/category/dveri-stalnye-protivopozharnye-raspashnye",
    "/shop/category/lestnitsy-promyshlennye",
    "/shop/category/metallicheskie-fermy",
    "/shop/category/metallicheskie-kolonny",
    "/shop/category/metallicheskie-ploshchadki-obsluzhivaniya-tekhnologicheskogo-oborudovaniya",
    "/shop/category/metallokonstruktsii",
    "/shop/category/progony",
    "/shop/category/proizvodstvo-dymokhodov-i-gazokhodov",
    "/shop/category/ramy-pod-oborudovanie",
    "/shop/category/svarnye-dvutavrovye-balki-",
    "/shop/category/vintovye-podemniki-i-vinty",
    "/shop/category/zakladnye-detali",
    "/shop/item/armatura-a500",
    "/shop/item/balka-dvutavrovaya",
    "/shop/item/goryachekatanyy-list",
    "/shop/item/lazernaya-rezka",
    "/shop/item/metallokonstruktsii-po-chertezham",
    "/shop/item/plazmennaya-rezka",
]);

export function getConsultationCopy(pathname: string | null | undefined, scopeState: CatalogueScopeState = 'unknown'): string {
    if (scopeState === 'excluded') return legacyConsultationCopy;
    if (scopeState === 'approved_non_support') return reviewedConsultationCopy;
    if (!pathname) return legacyConsultationCopy;
    const regionalPath = pathname.startsWith('/geo/msk/')
        ? pathname.slice('/geo/msk'.length)
        : pathname;
    const normalizedPath = regionalPath.endsWith('/')
        ? regionalPath.slice(0, -1)
        : regionalPath;
    return reviewedPaths.has(normalizedPath) ? reviewedConsultationCopy : legacyConsultationCopy;
}
